import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import {
  CHECKOUT_ORDER_ID_PARAM,
  LEGACY_NAV_TOP_UP_SOURCE,
  LEGACY_TOP_UP_SOURCE_PARAM,
  PRE_TOP_UP_TRANSACTION_ID_PARAM,
  parseCfDrawer,
  parseTransactionId,
} from '@/utils/cashflowsReturn'
import { CfStatus } from 'components/prize-draws/wallet/PaymentStatusBanner'
import { CfDrawer } from 'types/prize-draw/prize-draw'

export interface CashflowsReturnState {
  cfStatus: CfStatus
  cfDrawer: CfDrawer | null
  preTopUpTransactionId: number | null
  isNavTopUp: boolean
  checkoutOrderId: number | null
}

export function useCashflowsReturn() {
  const router = useRouter()

  const [cfStatus, setCfStatus] = useState<CfStatus>(null)
  const [cfDrawer, setCfDrawer] = useState<CfDrawer | null>(null)
  const [preTopUpTransactionId, setPreTopUpTransactionId] = useState<number | null>(null)
  const [isNavTopUp, setIsNavTopUp] = useState(false)
  const [checkoutOrderId, setCheckoutOrderId] = useState<number | null>(null)

  useEffect(() => {
    if (!router.isReady) return

    const [pathname, ...queryParts] = router.asPath.split('?')
    if (queryParts.length === 0) return

    const rawQuery = queryParts.join('&')
    const searchParams = new URLSearchParams(rawQuery)

    const cf_status = searchParams.get('cf_status')
    const cf_drawer = searchParams.get('cf_drawer')

    if (!cf_status && !cf_drawer) return

    if (cf_status) {
      const status = cf_status as CfStatus

      if (status === 'success' || status === 'failed' || status === 'cancelled') {
        setCfStatus(status)
      }
    }

    const drawer = parseCfDrawer(cf_drawer ?? undefined)
    if (drawer) setCfDrawer(drawer)

    setPreTopUpTransactionId(parseTransactionId(searchParams.get(PRE_TOP_UP_TRANSACTION_ID_PARAM)))
    if (drawer === 'checkout') {
      setCheckoutOrderId(parseTransactionId(searchParams.get(CHECKOUT_ORDER_ID_PARAM)))
      searchParams.delete(CHECKOUT_ORDER_ID_PARAM)
    }

    setIsNavTopUp(searchParams.get(LEGACY_TOP_UP_SOURCE_PARAM) === LEGACY_NAV_TOP_UP_SOURCE)
    searchParams.delete(PRE_TOP_UP_TRANSACTION_ID_PARAM)
    searchParams.delete(LEGACY_TOP_UP_SOURCE_PARAM)
    searchParams.delete('paymentjobref')
    searchParams.delete('paymentref')
    searchParams.delete('cf_status')
    searchParams.delete('cf_drawer')

    const newQueryStr = searchParams.toString()
    const newUrl = newQueryStr ? `${pathname}?${newQueryStr}` : pathname

    router.replace(newUrl, undefined, { shallow: true })
  }, [router.isReady])

  return { cfStatus, cfDrawer, preTopUpTransactionId, checkoutOrderId, isNavTopUp }
}
